import React from 'react';
import { Box, Typography, Grid, Divider } from '@mui/material';
import { Department } from './types';
import { PermitCard } from './PermitCard';

interface DepartmentSectionProps {
  department: Department;
}

export const DepartmentSection: React.FC<DepartmentSectionProps> = ({
  department
}) => {
  // Filter permits: Pet permit (ID 10) should only show for "Department of Health or Animal Control"
  const filteredPermits = department?.Permits?.filter((permit) => {
    // If it's a pet permit (PermitID 10), only show if department is "Department of Health or Animal Control"
    if (permit?.PermitID === 10) {
      return department?.DepartmentName === 'Department of Health or Animal Control';
    }
    // For all other permits, show them normally
    return true;
  });

  return (
    <Box sx={{ mb: 6 }}>
      <Typography
        variant="h4"
        sx={{ fontSize: '1.5rem', fontWeight: '700' }}
        component="h2"
        gutterBottom
      >
        {department?.DepartmentName}
      </Typography>
      {department?.Description && (
        <Typography variant="subtitle1" color="text.secondary" gutterBottom>
          {department?.Description}
        </Typography>
      )}
      <Grid
        container
        spacing={4}
        sx={{ mt: 2 }}
        justifyContent="center"
        alignItems="center"
      >
        {filteredPermits &&
          filteredPermits?.map((permit) => (
            <Grid item xs={12} md={6} lg={4} key={permit?.PermitID}>
              <PermitCard permit={permit} />
            </Grid>
          ))}
      </Grid>
      <Divider sx={{ mt: 6 }} />
    </Box>
  );
};
